import useAPI from "./useAPI";
import { DownloadService } from "../services/downloadService";
import { useCallback, useMemo } from "react";
import { downloadFile } from "../helper/DownloadFile";
import { DownloadServiceResponse } from "../services/downloadService/DownloadService.type";

/**
 * A hook which helps in simplifying document download.
 * Takes S3Key as input and downloads the file
 */
const useDocumentDownload = () => {
  const { callAPI: downloadDocument, loading } = useAPI(
    DownloadService.downloadEligibilityDocument
  );
  type documentDownloadType = (
    data: string,
    openInTab?: boolean,
    onSuccess?: (response?: DownloadServiceResponse) => void,
    onError?: (error: string) => void
  ) => void;
  const download: documentDownloadType = useCallback(
    (data, openInTab, onSuccess, onError) => {
      downloadDocument(
        data,
        fileResponse => {
          if (fileResponse) {
            downloadFile(fileResponse.downloadUrl, openInTab);
            if (onSuccess) {
              onSuccess(fileResponse);
            }
          }
        },
        onError
      );
    },
    [downloadDocument]
  );
  return useMemo(() => ({ download, loading }), [download, loading]);
};

export default useDocumentDownload;
